import cn from 'classnames';
import { useContext } from 'react';

import Button from 'components/common/Button';
import { PickYourMealsContext } from 'components/signUpFunnel/Contexts';
import { BrandContext, HOME_CHEF, TEMPO } from 'context/BrandContext';
import useBrand from 'hooks/useBrand';

const ThankYouButton = ({
  buttonStyles = 'w-96',
  onClick,
  postSignupUrl,
  user,
  variant = 'default',
}) => {
  const { coreUrl } = useContext(BrandContext);
  const isTempo = useBrand(TEMPO);
  const { isPickYourMeals } = useContext(PickYourMealsContext);

  const handleFormSubmit = e => {
    e.preventDefault();
    onClick();
    const form = e.currentTarget;
    const delay = isPickYourMeals ? 500 : 250;
    setTimeout(() => {
      form.submit();
    }, delay);
  };

  const handleButtonClick = () => {
    onClick();
    setTimeout(() => {
      window.location.href = postSignupUrl;
    }, 250);
  };

  if (!user) {
    return null;
  } else if (isTempo) {
    return (
      <form
        action={`${coreUrl}/tempo/signups`}
        method="POST"
        name="signup-completion"
        onSubmit={handleFormSubmit}
      >
        <input name="access_token" type="hidden" value={user.accessToken?.token} />
        <Button
          variation={variant === 'default' ? 'Secondary' : 'Primary'}
          type="submit"
          className={cn('btn m-auto my-4 flex w-full items-center justify-center bp1:w-128')}
        >
          {isPickYourMeals ? 'Complete Account Setup' : 'Select Meals'}
        </Button>
      </form>
    );
  } else {
    return (
      <Button
        variation={variant === 'default' ? 'Secondary' : 'Primary'}
        className={cn('btn m-auto my-4 flex items-center justify-center bp1:w-128', buttonStyles, {
          'bg-white-100 hover:bg-white-100 focus:bg-white-100': variant === 'default',
        })}
        onClick={handleButtonClick}
      >
        Select Meals
      </Button>
    );
  }
};

ThankYouButton.propTypes = {
  user: PropTypes.oneOfType([
    PropTypes.shape({
      accessToken: PropTypes.shape({ token: PropTypes.string.isRequired }).isRequired,
    }),
    () => null,
  ]),
  buttonStyles: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  brand: PropTypes.oneOf([HOME_CHEF, TEMPO]),
  postSignupUrl: PropTypes.string.isRequired,
  variant: PropTypes.oneOf(['default', 'primary']),
};

export default ThankYouButton;
